module.exports = __webpack_public_path__ + "img/email.27f2fd55.svg";